<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>车贷客户</span>
        <span>管理和维护您名下的车贷客户</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div class="item-box">
        <div class="noDataFlag">
          <van-empty description="暂无数据" v-show="dataList.length === 0" />
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
          <div class="item" v-for="(item, index) in dataList" :key="index">
            <div class="title">
              <span>客户姓名：{{ item.cname }}</span
              ><span>
                {{ parseDay(item.createDateTime) }}
              </span>
            </div>
            <div class="msg">
              <span>电话号码：</span><span>{{ item.phone }}</span>
            </div>
            <div class="msg">
              <span>所在城市：</span><span>{{ item.city }}</span>
            </div>
            <div class="msg">
              <span>需求金额：</span><span>{{ item.requiredAmount }}万</span>
            </div>
            <div class="msg">
              <span>评估金额：</span><span>{{ item.evaluationPrice }}万</span>
            </div>
            <div class="msg">
              <span>车辆品牌：</span><span>{{ item.vehicleBrand }}</span>
            </div>
            <div class="msg">
              <span>车辆状态：</span><span>{{ item.vehicleStatus }}</span>
            </div>
            <div class="msg">
              <span>购买时间：</span
              ><span>{{ parseDay(item.purchaseTime) }}</span>
            </div>
            <div class="msg">
              <span>备注信息：</span
              ><span>{{ item.customerServiceRemarks }}</span>
            </div>
            <div class="msg">
              <span>创建时间：</span
              ><span>{{ parseTime(item.createDateTime) }}</span>
            </div>
            <div class="btn">
              <van-button
                icon="phone"
                v-show="item.phone"
                @click="toCall(item.phone)"
                >联系客户</van-button
              >
              <van-button
                icon="smile-comment"
                @click="toPage('maintainRecords', item)"
                >维护记录</van-button
              >
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { parseTime, parseDay } from "@/utils/index.js";
import {
  Button,
  RadioGroup,
  Radio,
  Toast,
  Notify,
  Picker,
  Form,
  Empty,
  List,
  Field,
  Dialog,
} from "vant";
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(List);
Vue.use(Form);
import { getCurrentChannelInfo } from "@/api/login.js";
import { xcVehicleLoan } from "@/api/carLoanCustomers.js";
import { areaList } from "@vant/area-data";
import Vue from "vue";
export default {
  components: {},
  mounted() {},
  created() {
    // 获取渠道用户信息
    getCurrentChannelInfo().then((res) => {
      this.channelInfo = res;
    });
  },
  data() {
    return {
      form: {},
      dataList: [],
      query: {
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
        createDateTime: [],
      },
      loading: false,
      finished: false,
      channelInfo: {},
      noDataFlag: false,
    };
  },
  methods: {
    parseTime,
    parseDay,
    toPage(name, item) {
      switch (name) {
        case "toApply":
          break;
        case "maintainRecords":
          this.$router.push({
            path: "/" + name,
            query: { id: item.id },
          });
          break;
      }
    },
    onConfirm() {},
    submit() {},
    toUrl() {
      let domain = "https://apply.xchengtech.cn";
      let url = domain + "/#/carLoan?channelId=" + this.channelInfo.id;
      console.log("url", url);
    },
    getData() {
      xcVehicleLoan(this.query)
        .then((res) => {
          this.dataTotal = res.totalElements;
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.query.page++;
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log("err", err);
          this.loading = false;
          this.finished = true;
          Toast.clear();
        });
    },
    onLoad() {
      this.loading = true;
      this.getData();
    },
    toCall(phone) {
      window.open("tel:" + phone);
    },
    onSearch() {
      this.query.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.getData();
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/carLoanCustomers/index.vue